var _rect, _circle, _line, _line2, _line3, _line4, _line5, _line6, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExtendLoanPeriod(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 27.6863,
    y: 26.6367,
    width: 67.8117,
    height: 67.8117,
    fill: "#AFFFD1"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.2745,
    cy: 24.5776,
    r: 10.2745,
    stroke: "#16161E",
    strokeWidth: 4
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 13.2471,
    y1: 1.46179,
    x2: 13.2471,
    y2: 14.3049,
    stroke: "#16161E",
    strokeWidth: 4
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 13.2471,
    y1: 34.8535,
    x2: 13.2471,
    y2: 79.0338,
    stroke: "#16161E",
    strokeWidth: 4
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 42.5293,
    y1: 1.46179,
    x2: 42.5293,
    y2: 50.7794,
    stroke: "#16161E",
    strokeWidth: 4
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 70.7839,
    y1: 1.46179,
    x2: 70.7839,
    y2: 29.7167,
    stroke: "#16161E",
    strokeWidth: 4
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 42.5293,
    y1: 67.7322,
    x2: 42.5293,
    y2: 79.0341,
    stroke: "#16161E",
    strokeWidth: 4
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 70.7839,
    y1: 53.3474,
    x2: 70.7839,
    y2: 79.0336,
    stroke: "#16161E",
    strokeWidth: 4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 32.8232,
    y: 50.2645,
    width: 17.4666,
    height: 17.4666,
    stroke: "#16161E",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.8118 29.7159L80.0444 35.6238V47.4394L69.8118 53.3473L59.5791 47.4394V35.6238L69.8118 29.7159Z",
    stroke: "#16161E",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtendLoanPeriod);
export default __webpack_public_path__ + "static/media/extend_loan_period.066b2b7d15551b6a4b1e38a8fe79c098.svg";
export { ForwardRef as ReactComponent };